module.exports = __webpack_public_path__ + "static/img/7.b19c7a4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/zh/7.png
// module id = UunA
// module chunks = 0